import React, { useEffect, useState } from 'react';
import styles from './tattoo_olavotattoo.module.scss';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const images = Array.from({ length: 39 }, (_, i) => require(`./src/tattoo/${i + 1}.png`));

const Tattoo_olavotattoo: React.FC = () => {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openModal = (index: number) => setSelectedIndex(index);
    const closeModal = () => setSelectedIndex(null);
    const prevImage = () => setSelectedIndex((prev) => (prev! > 0 ? prev! - 1 : images.length - 1));
    const nextImage = () => setSelectedIndex((prev) => (prev! < images.length - 1 ? prev! + 1 : 0));

    return (
        <div className={styles.tattoo_olavotattoo}>
            <div className={styles.header}>
                <Link to="/olavotattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1>Tattoo's</h1>
                <div className={styles.line}></div>
            </div>

            <div className={styles.gallery}>
                {images.map((src, index) => (
                    <div className={styles.imageWrapper} key={index} onClick={() => openModal(index)}>
                        <img src={src} alt={`Foto ${index + 1}`} />
                    </div>
                ))}
            </div>

            {selectedIndex !== null && (
                <div className={styles.modal}>
                    <button className={styles.close} onClick={closeModal}>
                        <FaTimes />
                    </button>
                    <button className={styles.prev} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img src={images[selectedIndex]} alt={`Foto ampliada ${selectedIndex + 1}`} />
                    <button className={styles.next} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default Tattoo_olavotattoo;
